export default class STR_N {
    static userNameLeng(str: string, n: number) {
        return str.length <= n ? str : str.slice(0, n) + '...';
    }
}
